import { useLayoutEffect, useRef, useState } from 'react';
import { cn } from './cn';

function isTextTruncated(element) {
  const { clientWidth, scrollWidth, clientHeight, scrollHeight } = element;

  if (scrollWidth - clientWidth > 1 || scrollHeight - clientHeight > 1) {
    return true;
  }

  const range = document.createRange();
  range.selectNodeContents(element);
  return range.getBoundingClientRect().width - element.getBoundingClientRect().width > 1;
}

export default function EllipseTooltip({ children, className, title, showTooltip = true }) {
  const ref = useRef(null);
  const [truncated, setTruncated] = useState(false);
  const tooltipText = title ?? (typeof children === 'string' ? children : undefined);

  useLayoutEffect(() => {
    if (!showTooltip) {
      setTruncated(false);
      return;
    }

    const element = ref.current;
    if (!element) return;

    const checkTruncation = () => {
      setTruncated(isTextTruncated(element));
    };

    checkTruncation();

    const observer = new ResizeObserver(checkTruncation);
    observer.observe(element);
    if (element.parentElement) {
      observer.observe(element.parentElement);
    }

    return () => observer.disconnect();
  }, [children, showTooltip, title]);

  return (
    <span
      ref={ref}
      className={cn('block w-full min-w-0 max-w-full truncate', className)}
      title={showTooltip && truncated && tooltipText ? tooltipText : undefined}
    >
      {children}
    </span>
  );
}
